export interface TutorialSlide {
  id: number
  title: string
  description: string
  /** Screenshot of the matching in-game state, captured from a real playthrough */
  image: string
  annotations: {
    text: string
    position: "top-left" | "top-right" | "bottom-left" | "bottom-right"
  }[]
}

export const tutorialSlides: TutorialSlide[] = [
  {
    id: 1,
    title: "Objective",
    description:
      "Protect your base from enemy attacks. Build defense towers along the road to stop them!",
    image: "/images/tutorial/slide-1-objective.png",
    annotations: [
      {
        text: "Lives you have left",
        position: "top-left",
      },
      {
        text: "Tap to call the next wave",
        position: "top-right",
      },
      {
        text: "Your base - defend it!",
        position: "bottom-left",
      },
      {
        text: "Enemies follow the road to it",
        position: "bottom-right",
      },
    ],
  },
  {
    id: 2,
    title: "Tower Construction",
    description:
      "Tap a build spot beside the road to open the build ring, then pick the tower you want.",
    image: "/images/tutorial/slide-2-build.png",
    annotations: [
      {
        text: "Gold you have to spend",
        position: "top-left",
      },
      {
        text: "Tap a build spot for this ring",
        position: "top-right",
      },
      {
        text: "Every icon shows its price",
        position: "bottom-left",
      },
      {
        text: "Pick one to build it there",
        position: "bottom-right",
      },
    ],
  },
  {
    id: 3,
    title: "Basic Tower Types",
    description: "Four basic tower types are available. Each has unique strengths!",
    image: "/images/tutorial/slide-3-towers.png",
    annotations: [
      {
        text: "Archer - fast, reliable damage",
        position: "top-left",
      },
      {
        text: "Mage - heavy magic damage",
        position: "top-right",
      },
      {
        text: "Barracks - soldiers block the road",
        position: "bottom-left",
      },
      {
        text: "Artillery - slow splash damage",
        position: "bottom-right",
      },
    ],
  },
  {
    id: 4,
    title: "Hero & Items",
    description:
      "Your hero fights alongside your towers. Equip dropped items to boost power, and sell what you don't need.",
    image: "/images/tutorial/slide-4-hero.png",
    annotations: [
      {
        text: "Your hero auto-attacks enemies",
        position: "top-left",
      },
      {
        text: "Level up to unlock skills",
        position: "top-right",
      },
      {
        text: "Portrait, health, mana and XP",
        position: "bottom-left",
      },
      {
        text: "Inventory - equip or sell items",
        position: "bottom-right",
      },
    ],
  },
  {
    id: 5,
    title: "Premium Towers",
    description:
      "Premium towers add special abilities. Connect a BSV wallet and spend crystals to build them.",
    image: "/images/tutorial/slide-5-premium.png",
    annotations: [
      {
        text: "Shrine - buffs your hero's aura",
        position: "top-left",
      },
      {
        text: "Connect a BSV wallet to unlock",
        position: "top-right",
      },
      {
        text: "Tap one to see what it does",
        position: "bottom-left",
      },
      {
        text: "Free tokens let you try them",
        position: "bottom-right",
      },
    ],
  },
]
